import { Injectable } from '@angular/core';
import { PopoverController, PopoverOptions } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class PopoverService {

  constructor(
    private readonly popoverController: PopoverController,
  ) {}

  async simple(opts: PopoverOptions): Promise<HTMLIonPopoverElement> {
    const popover = await this.popoverController.create({
      showBackdrop: true,
      backdropDismiss: false,
      translucent: true,
      cssClass: 'popover-centered',
      animated: false,
      ...opts,
    });
    await popover.present();
    return popover;
  }

  async hidePopover() {
    return this.popoverController.dismiss().catch(() => {});
  }
}
